import { io } from 'socket.io-client';

import { TERBEBAS_API_BASE, TERBEBAS_STORE_SLUG } from './terbebasApi';

// Livestream realtime plane (viewer presence + chat), served by
// terbebas-backend's socket.io on the same origin as the REST API.
// The handshake scopes this connection to the store's rooms; identity
// details (name, watch state) follow via 'viewer:state' events.
const SOCKET_URL = TERBEBAS_API_BASE.replace(/\/api\/?$/, '');

export const socket = io(SOCKET_URL, {
  auth: {
    storeSlug: TERBEBAS_STORE_SLUG,
    role: 'viewer',
  },
});
